<div class="container">
  <div class="title-text">
    Sorry, page not found!
  </div>

  @for (toMakeButton of toMakeButtons.slice(0,2); track toMakeButton) {
    <a
      mat-fab
      extended
      color="primary"
      class="button"
      [routerLink]="toMakeButton.path">
      {{toMakeButton.name}}
    </a>
  }
</div>